import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/home.vue')
    },
    {
      path: '/solution',
      name: 'solution',
      component: () => import('../views/solution/index.vue')
    },
    {
      path: '/solution/detail',
      name: 'solutionDetail',
      component: () => import('../views/solution/detail.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/about.vue')
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('../views/product.vue')
    },
    {
      path: '/product/index',
      name: 'productIndex',
      component: () => import('../views/product/index.vue')
    },
    {
      path: '/product/detail',
      name: 'productDetail',
      component: () => import('../views/product/detail.vue')
    },
    {
      path: '/support',
      name: 'support',
      component: () => import('../views/support.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('../views/news/index.vue'),
    },
    {
      path: '/news/detail',
      name: 'newsDetail',
      component: () => import('../views/news/detail.vue'),
    },
    {
      path: '/atmosphere',
      name: 'atmosphere',
      component: () => import('../views/atmosphere.vue')
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js